/**
 * WeaponKatana — long single-edged curved blade.
 * Slender blade with a slight taper to the tip; round tsuba (guard); wrapped tsuka.
 * Renders as an SVG <g> group in the knight's coordinate space (25×25).
 */
export default function WeaponKatana() {
  return (
    <g>
      {/* Blade — long and slim with slight curve offset */}
      <rect x="21.5" y="0.5" width="1.6" height="18" rx="0.3" fill="#eaf2fa"/>
      {/* Edge highlight (cutting edge) */}
      <rect x="21.5" y="0.5" width="0.6" height="17" rx="0.2" fill="#ffffff" opacity="0.75"/>
      {/* Back edge */}
      <rect x="22.7" y="1"   width="0.4" height="16" rx="0.2" fill="#b8ccdc" opacity="0.80"/>
      {/* Kissaki — blade tip */}
      <path d="M21.5 0.5 Q22.3 -0.5 23.1 0.5" fill="#eaf2fa"/>
      {/* Ha-machi (blade-collar notch) */}
      <rect x="21"   y="17.5" width="3"   height="1.2" rx="0.3" fill="#c09828"/>
      {/* Tsuba (round guard) */}
      <ellipse cx="22.1" cy="19.4" rx="3.2" ry="1.3" fill="#7a5820" stroke="#d4aa40" strokeWidth="0.7"/>
      {/* Tsuka (handle) */}
      <rect x="21.2" y="20"   width="1.8" height="5.5" rx="0.4" fill="#3a2a1a"/>
      {/* Tsuka-ito wrap diamonds */}
      <rect x="20.8" y="21.2" width="2.6" height="0.6" rx="0.2" fill="#8a6030" opacity="0.9" transform="rotate(-10 22 21.5)"/>
      <rect x="20.8" y="22.6" width="2.6" height="0.6" rx="0.2" fill="#8a6030" opacity="0.9" transform="rotate(-10 22 22.9)"/>
      <rect x="20.8" y="24"   width="2.6" height="0.6" rx="0.2" fill="#8a6030" opacity="0.9" transform="rotate(-10 22 24.3)"/>
      {/* Kashira (pommel cap) */}
      <ellipse cx="22.1" cy="26" rx="1.6" ry="0.8" fill="#5a3a18" stroke="#d4aa40" strokeWidth="0.5"/>
    </g>
  );
}
